import { Trans, useLingui } from '@lingui/react/macro';

import { AlertFloating } from '@/components/application/alerts/alerts';
import { LinkButton } from '@/components/base/buttons/button';

export function AccountExistsNotice({
  email,
  returnTo,
}: {
  email: string;
  /**
   * Where the visitor was headed before signup sent them here. Carried into
   * log in only: `/forgot-password` has no way to resume it, and the reset
   * link lands them back on log in anyway.
   */
  returnTo?: string;
}) {
  const { t } = useLingui();
  const search = { email: email.trim() || undefined };
  return (
    <AlertFloating
      color="error"
      title={t`An account with this email already exists`}
      description={
        <>
          <LinkButton
            size="sm"
            color="link-color"
            to="/login"
            search={{ ...search, returnTo }}
            data-testid="signup-account-exists-login-link"
          >
            <Trans>Log in</Trans>
          </LinkButton>{' '}
          or{' '}
          <LinkButton
            to="/forgot-password"
            search={search}
            size="sm"
            color="link-color"
            data-testid="signup-account-exists-reset-link"
          >
            <Trans>reset your password</Trans>
          </LinkButton>
        </>
      }
    />
  );
}
